export default "__VITE_ASSET__DVj$ejoe__"